import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  tabHeading: {
    textTransform: 'none',
    minWidth: theme.spacing(11),
  },
}));
